$(function () {
fn_layout_header();
fn_layout_main();
fn_part_ui_heading();
fn_part_ui_input();
fn_part_ui_number();
fn_part_ui_option();
fn_part_ui_select();
fn_part_ui_wsw();
fn_comp_contact();
fn_comp_encyclopedia_references();
fn_comp_highlights();
fn_comp_hp_maxinfo();
fn_comp_hp_references();
fn_comp_map();
fn_comp_maxinfo();
fn_comp_reviews();
fn_comp_school();
fn_comp_visual();
});